import { render, staticRenderFns } from "./CodePostal.vue?vue&type=template&id=2b31c178"
import script from "./CodePostal.vue?vue&type=script&lang=js"
export * from "./CodePostal.vue?vue&type=script&lang=js"
import style0 from "./CodePostal.vue?vue&type=style&index=0&id=2b31c178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports